import React from 'react';
import SheetMenu from '../structural/sheet/menu/SheetMenu';
import { canvasContextMenuConnect } from '../../workspace/contextMenu/CanvasContextMenuItemsContainer';
import Icon from '../../components/icons/Icon';

type MobileCanvasContextMenuContentProps = {
    showUndo: boolean;
    showRedo: boolean;
    showPaste: boolean;
    showSelectAll: boolean;
    paste: () => void;
    dispatchUndoAction: () => void;
    dispatchRedoAction: () => void;
    dispatchSelectAll: () => void;
    dispatchCloseSheet: () => void;
};

const MobileCanvasContextMenuContent = ({
    showUndo,
    showRedo,
    showPaste,
    showSelectAll,
    paste,
    dispatchUndoAction,
    dispatchRedoAction,
    dispatchSelectAll,
    dispatchCloseSheet,
}: MobileCanvasContextMenuContentProps) => {
    const menuItems = [
        {
            label: 'Undo',
            onClick: dispatchUndoAction,
            icon: <Icon name="context-menu-undo" />,
            dismissSheetOnSelect: true,
            visible: showUndo,
        },
        {
            label: 'Redo',
            onClick: dispatchRedoAction,
            icon: <Icon name="context-menu-redo" />,
            dismissSheetOnSelect: true,
            visible: showRedo,
        },
        {
            label: 'Paste',
            onClick: paste,
            icon: <Icon name="context-menu-paste" />,
            dismissSheetOnSelect: true,
            visible: showPaste,
        },
        {
            label: 'Select all',
            onClick: dispatchSelectAll,
            icon: <Icon name="context-menu-select-all" />,
            dismissSheetOnSelect: true,
            visible: showSelectAll,
        },
    ];

    const hasAvailableActions = menuItems.some((item) => item.visible);

    if (!hasAvailableActions) {
        dispatchCloseSheet();
        return null;
    }

    return <SheetMenu menuItems={menuItems} />;
};

export default canvasContextMenuConnect(MobileCanvasContextMenuContent);
